<app-public-header></app-public-header>

<div class="welcome-wrap">
  <h3>Multi-Factor Authentication</h3>
  <p>Please enter the verification code sent to your email</p>
  <p class="text-muted small">Email: {{ mfaState.email }}</p>

  <form
    #form="ngForm"
    class="row g-3 mfa-form"
    [formGroup]="mfaForm"
    novalidate
    (submit)="onSubmit()"
  >
    <div class="col-md-12">
      <label for="token" class="form-label">Verification code</label>
      <input
        class="form-control text-center mfa-input"
        [ngClass]="{
          'is-invalid': (form.submitted || f.token.touched) && f.token.invalid,
          'is-valid': f.token.valid,
        }"
        id="token"
        type="text"
        placeholder="Enter 6-digit code"
        formControlName="token"
        aria-label="Enter verification code"
        maxlength="6"
      />
      <div
        *ngIf="f.token.invalid && ((f.token.dirty && f.token.touched) || form.submitted)"
        class="invalid-feedback"
      >
        Please enter a valid 6-digit verification code
      </div>
    </div>

    <div class="col-12">
      <button type="submit" class="btn btn-green" [disabled]="mfaForm.invalid">Verify Code</button>
    </div>

    <div class="col-12 text-center">
      <button
        type="button"
        class="btn btn-green"
        [disabled]="isResendingToken || resendCooldown > 0"
        (click)="sendToken()"
      >
        <ng-container *ngIf="isResendingToken">Sending...</ng-container>
        <ng-container *ngIf="!isResendingToken && resendCooldown > 0">
          Resend code in {{ resendCooldown }}s
        </ng-container>
        <ng-container *ngIf="!isResendingToken && resendCooldown === 0">
          Resend verification code
        </ng-container>
      </button>
    </div>

    <div class="col-12 text-center">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onBackToLogin()">
        Back to Login
      </button>
    </div>
  </form>
</div>

<app-public-footer></app-public-footer>
